var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-main"},[_c('router-view'),_c('employee-schedule-dialog',{attrs:{"visible":_vm.scheduleVisible,"open-mode":_vm.scheduleDialogMode},on:{"update:visible":function($event){_vm.scheduleVisible = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }